import { useDirection } from "@jti/fe-common";

export const brandIcons: React.SVGAttributes<SVGSVGElement> = {
  width: "1em",
  height: "1em",
  viewBox: "0 0 100 100",
  fill: "currentColor",
};

type DirectionalIconComponentProps = React.SVGProps<SVGSVGElement> & { direction?: "ltr" | "rtl" };
export type DirectionalIconComponent = React.FC<DirectionalIconComponentProps>;

function iconFactory(iconName: string, Ltr: SvgrComponent): DirectionalIconComponent;
function iconFactory(iconName: string, Ltr: SvgrComponent, Rtl: SvgrComponent): DirectionalIconComponent;
function iconFactory(iconName: string, LtrSvg: SvgrComponent, RtlSvg?: SvgrComponent): DirectionalIconComponent {
  if (RtlSvg === undefined) {
    const Icon: DirectionalIconComponent = (props) => {
      return <LtrSvg data-dir="ltr" data-name={iconName} {...brandIcons} {...props} />;
    };
    Object.defineProperty(Icon, "name", { value: iconName, writable: false });

    return Icon;
  }
  const Icon: DirectionalIconComponent = (props) => {
    const { direction, ...restProps } = props;
    const dir = useDirection(direction);
    const Component = dir === "rtl" ? RtlSvg : LtrSvg;

    return <Component data-dir={dir} data-name={iconName} {...brandIcons} {...restProps} />;
  };
  Object.defineProperty(Icon, "name", { value: iconName, writable: false });

  return Icon;
}

export { iconFactory };
